import { AppRouteProps } from "@harea/component"
import PaymentMethodContainer from "./container/PaymentMethodContainer"

export const PaymentMethodRoutes: Array<AppRouteProps> = [
    {
        path: "payment-method",
        title: "std_payment_method",
        element: <PaymentMethodContainer />
    }
];
